import qs from 'qs'
import fetch from '../utils/Fetch'
import config from '@/config/Config.vue'

//用户登录获取验证码
export function loginByUsersend(data) {
    return fetch({
        url: config.WEB_LOGINCODE_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
//用户登录方法
export function loginByUsername(data) {
    return fetch({
        url: config.WEB_LOGIN_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
//用户退出方法
export function logout(data) {
    return fetch({
        url: config.WEB_LOGOUT_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
//登录绑定检查
export function loginBind(data) {
    return fetch({
        url: config.WEB_LOFINBIND_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}

//登录绑定检查
export function wxCode(data) {//http://www.ltech.net.cn/#/
    return fetch({
        url: "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx7ff1032defe0198f&redirect_uri=https://parking-saas-test.chinasinoair.com/&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect",
        // url: "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx7ff1032defe0198f&redirect_uri=http://www.ltech.net.cn&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect",
        method: 'POST',
        data: qs.stringify(data)
    })
}
// 获取图形验证码
export function getKaptchaUrl(data) {
  return fetch({
    url: config.KAPTCHA_GET_API,
    method: 'post',
    data: qs.stringify(data)
  })
}
